import { render, staticRenderFns } from "./xcx.vue?vue&type=template&id=01a366da&scoped=true"
import script from "./xcx.vue?vue&type=script&lang=js"
export * from "./xcx.vue?vue&type=script&lang=js"
import style0 from "./xcx.vue?vue&type=style&index=0&id=01a366da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a366da",
  null
  
)

export default component.exports